/**
 * Cadre en pointillé affiché par-dessus la carte pendant l'édition interactive de la vue par
 * défaut (voir `MapLibreAdapter.startEditingMapView`) — signale que la carte est dans un mode
 * particulier. Un `<div>` dédié, superposé (voir style.css : `position: absolute; inset: 0`),
 * plutôt qu'un `outline`/`border` posé directement sur `#map` : ce dernier a son propre contenu
 * (canvas MapLibre, overlay d'images SVG des formes) qui se peint par-dessus les décorations de
 * `#map` lui-même, un cadre posé directement dessus se retrouverait donc caché derrière ce
 * contenu — ce widget, positionné comme les autres (croix, tutoriel...) directement dans
 * `container`, n'a pas ce problème.
 */
export class MapViewFrame {
  private element: HTMLDivElement | null = null;

  constructor(private container: HTMLElement) {}

  show(): void {
    if (this.element) return;

    this.element = document.createElement("div");
    this.element.className = "toka-map-view-frame";
    this.container.appendChild(this.element);
  }

  hide(): void {
    this.element?.remove();
    this.element = null;
  }
}
